<div class="container notification-page">
   <loader [loading]="isLoading"></loader>
   <crm-alert #alert></crm-alert>
  <div class="row block-notify">
    <div class="col-8">
      <div class="group-header">Report Notifications
        <div class="checkbox-item ml-auto">
          <input class="checkbox-custom" type='checkbox' name="reportNotification" id="reportNotification"
          value="true" [(ngModel)]="isReportNoficationChecked" (ngModelChange)="onReportNotificationCheckChanged($event)"/>
          <label style="font-size: 13px;" class="checkbox-custom-label" for="reportNotification">Check All</label>
        </div>
      </div>

      <div class="notifications">
        <div class="checkbox-item notification" *ngFor="let n of notifications | nGroupFilter: NotificationGroup.REPORT">
          <input class="checkbox-custom" type='checkbox' name="checkItem-{{n?.ID}}" id="checkItem-{{n?.ID}}"
                 [(ngModel)]="n.SELECTED" (ngModelChange)="notificationToggle(n)"/>
          <label class="checkbox-custom-label" [for]="'checkItem-'+n?.ID">{{n?.NAME}}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row block-notify">
    <div class="col-8">
      <div class="group-header">Report Watching Notifications
        <div class="checkbox-item ml-auto">
          <input class="checkbox-custom" type='checkbox' name="reportWatchingNotification" id="reportWatchingNotification"
          value="true" [(ngModel)]="isReportWatchNoficationChecked" (ngModelChange)="onReportWatchNotificationCheckChanged($event)" />
          <label style="font-size: 13px;" class="checkbox-custom-label" for="reportWatchingNotification">Check All</label>
        </div>
      </div>

      <div class="notifications">
        <div class="checkbox-item notification" *ngFor="let n of notifications | nGroupFilter: NotificationGroup.WATCH">
          <input class="checkbox-custom" type='checkbox' name="checkItemW-{{n?.ID}}" id="checkItemW-{{n?.ID}}"
                 [(ngModel)]="n.SELECTED" (ngModelChange)="notificationToggle(n)"/>
          <label class="checkbox-custom-label" [for]="'checkItemW-'+n?.ID">{{n?.NAME}}</label>
        </div>
      </div>
    </div>
  </div>

</div>
